<form [formGroup]="editorForm" enctype='multipart/form-data'>
    <div class='dataIn'>
        <input  *ngIf="editVal !== true" placeholder="Seller Name" type="text" formControlName="seller">
        <input  *ngIf="editVal === true" type="text" formControlName="seller">

        <input placeholder="Email" type="text" formControlName="email">
        <input placeholder="Item" type="text" formControlName="item">
        <select class="groupSelect" name="category" formControlName="category" required>
            <option value="" selected disabled hidden>Select Category</option>
            <option value="interior">Interior Construction</option> 
            <option value="plumbing">Plumbing</option>      
            <option value="roofing">Roofing</option>       
            <option value="electrical">Electrical</option>
            <option value="yard">Yard</option>
        </select>
        <input placeholder="Price" type="number" formControlName="price" min="0" max="10">
        <input placeholder="Address" type="text" formControlName="address">
        <input placeholder="City" type="text" formControlName="city">
        <input placeholder="State" type="text" formControlName="state">
        <input placeholder="Zip Code" type="text" formControlName="zipcode">
        <input placeholder="Summary (30 Characters max)" type="text" formControlName="short_details" maxlength="30">

        <quill-editor placeholder="Description" id="quill" formControlName="editor"></quill-editor>
        <h4 *ngIf="!replaced && editVal">Replace images?</h4>
        <button *ngIf="!replaced && editVal"  class="replacedNo" (click)="replaceImages(replaceVal)" #replaceButton>Yes</button>
        <input *ngIf="replaceVal || addVal" type="file" (change)="imgUpload($event)" accept="*png.jpg" formControlName="images" multiple>
        <input placeholder="Tags | Separate with commas." type="text" formControlName="tags">
    </div>
    <button *ngIf="editVal !== true" [disabled]="!editorForm.valid || imagesGet === 0" (click)="newPost()">Submit</button>
    <button *ngIf="editVal === true" (click)="newPost()" [disabled]="!editorForm.valid || (imagesGet === 0 && replaced === true)">Submit</button>
    <div class='loading' *ngIf="submitted==='loading'">
        <img src="../../assets/img/ExcessMaterialLoading.png" alt="">
        <h1>SENDING...</h1>
    </div>
    <div class='success' *ngIf="submitted==='submitted'">
        <h1>SUCCESS!</h1>
    </div>
</form>
<!-- <h4 *ngIf="editorForm.get('address').forbiddenAddress" style="color: red;">Address not allowed</h4> -->
